/**
 * @module Utilities/Location
 * @desc Location helper funtions
 */

import { getLocationPathname } from 'core/utilities/helpers';

import { hasPathnamePrefix, isValidLocalePrefix } from './has-pathname-prefix';

/**
 * Returns a pathname with prefix if needed
 *
 */
export function getBasePathname(pathname: string = getLocationPathname()) {
  if (!hasPathnamePrefix(pathname)) {
    const currentPathname = getLocationPathname();
    const [country, locale] = currentPathname.split('/').slice(1);

    /* istanbul ignore else */
    if (isValidLocalePrefix(country, locale)) {
      return `/${country}/${locale}${pathname}`;
    }
  }

  return pathname;
}
